<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doFilter"
    class="filter"
    ref="form"
  >
    <el-row>
      <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.id.label" :prop="fields.id.name">
          <el-input v-model="model[fields.id.name]" />
        </el-form-item>
      </el-col>

      <el-col style="margin-bottom: -0.41px;" :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.createdAtRange.label" :prop="fields.createdAtRange.name">
          <el-date-picker type="datetimerange" v-model="model[fields.createdAtRange.name]"></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>

    <div class="filter-buttons">
      <el-button :disabled="loading" @click="doFilter" icon="el-icon-fa-search" type="primary">
        <app-i18n code="common.search"></app-i18n>
      </el-button>

      <!-- <el-button :disabled="loading" @click="doResetFilter" icon="el-icon-fa-undo">
        <app-i18n code="common.reset"></app-i18n>
      </el-button>-->
    </div>
  </el-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FilterSchema } from '@shared/form/filter-schema';
import { CategoryModel } from '@modules/category/category-model';

export default {
  name: 'app-category-list-filter',

  data() {
    return {
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'category/list/loading',
      filter: 'category/list/filter',
      currentManage: 'auth/manage/currentManage',
      dateFormat: 'auth/manage/dateFormat',
      populateDate: 'auth/manage/populateDate',
    }),

    rules() {
      const { filterSchema } = this;
      return filterSchema.rules();
    },

    filterSchema() {
      const { fields } = this;
      return new FilterSchema([
        fields.id,
        fields.name,
        fields.createdAtRange,
      ]);
    },

    fields() {
      const { dateFormat, populateDate } = this;
      return new CategoryModel({ dateFormat, populateDate }).fields();
    },
  },

  async mounted() {
    const { filterSchema } = this;

    this.model = filterSchema.initialValues(
      this.filter,
      this.$route.query,
    );

    return this.doFilter();
  },

  methods: {
    ...mapActions({
      doReset: 'category/list/doReset',
      doFetch: 'category/list/doFetch',
    }),

    async doResetFilter() {
      const { filterSchema } = this;

      this.model = filterSchema.initialValues();
      this.$refs.form.clearValidate();
      return this.doReset();
    },

    async doFilter() {
      const { filterSchema } = this;

      try {
        await this.$refs.form.validate();
        this.$refs.form.clearValidate();
      } catch (error) {
        return;
      }

      const filter = filterSchema.cast(this.model);
      return this.doFetch({
        filter,
        manage: this.currentManage,
      });
    },
  },
};
</script>

<style>
</style>
